// extracted by mini-css-extract-plugin
export default {"link":"Link_link__h0DL5"};